module.exports = __webpack_public_path__ + "static/media/icon_send-message.188dc9fd.svg";